import { rest, RestHandler } from 'msw';
import { PATHS } from 'adapters/constants';
import { printChecksTableData } from 'mocks/mockData/printChecksTableData';

export const printChecksTableHandler: RestHandler[] = [
  rest.get(
    `${PATHS.getVendorsServicePath('*')}/print-authorized`,
    (_, res, ctx) => res(ctx.status(200), ctx.json(printChecksTableData))
  )
];
